import React from 'react';

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import styled from 'styled-components';
import { StyledBox, StyledButton, StyledDivider, StyledGrid, StyledTypography } from 'styles/common';

import { StyledIcon } from 'constants/icons';

const FooterWrapper = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
`;

const FixedWidthButton = styled(StyledButton)`
  &.MuiButtonBase-root {
    min-width: 150px;
  }
`;

const CustomStyledButton = styled(FixedWidthButton)`
  &.MuiButton-root.Mui-disabled {
    color: white;
    background-color: #87bcee;
  }
`;

export const PanelFooter = ({ primaryText, secondaryText, primaryHandler, secondaryHandler, canSave = true }) => (
  <FooterWrapper>
    <FixedWidthButton
      variant="outlined"
      customColor="white"
      fontColor="primary"
      onClick={secondaryHandler}
      borderColor="primary"
      padding=".5rem 1rem"
    >
      <StyledTypography variant="body1">{secondaryText}</StyledTypography>
    </FixedWidthButton>
    <CustomStyledButton
      customColor={canSave ? 'primary' : null}
      variant="contained"
      fontColor="white"
      onClick={primaryHandler}
      disabled={!canSave}
      padding=".5rem 1rem"
      leftGutter={2}
      disableElevation
    >
      <StyledTypography variant="body1">{primaryText}</StyledTypography>
    </CustomStyledButton>
  </FooterWrapper>
);

export const CompanyResponseHover = ({ data }) => (
  <StyledBox padding="1rem" width="40ch">
    <StyledGrid>
      <StyledTypography variant="body1" weight={600}>
        Distribution
      </StyledTypography>
    </StyledGrid>
    <StyledDivider topGutter={2} bottomGutter={2} />
    <StyledGrid direction="column">
      {data.map(({ optionTitle, count, color }) => (
        <CompanyResponseRow key={optionTitle} text={optionTitle} count={count} color={color} />
      ))}
    </StyledGrid>
  </StyledBox>
);

const getColorFromKey = (color) => color;
const CompanyResponseRow = ({ text, count, color }) => (
  <StyledGrid container>
    <StyledGrid container item xs={7} wrap="nowrap">
      <StyledIcon size="header" color={getColorFromKey(color)} rightGutter={1}>
        <FiberManualRecordIcon />
      </StyledIcon>
      <StyledTypography variant="body1" truncate>
        {text}
      </StyledTypography>
    </StyledGrid>
    <StyledGrid container item xs={5} justify="flex-end">
      <StyledTypography variant="body1" color="textSecondary">
        {`${count} Employee`}
      </StyledTypography>
    </StyledGrid>
  </StyledGrid>
);
